import { ZmlMediaFile } from './zml'

export enum ImgRecMedia{
    Ready = 'Ready',
    Pending = 'Pending',
    Deleted = 'Deleted',
    Error = 'Error',
}

export enum ImgRecImageStatus{
    Failed = 'Failed',
    Ready = 'Ready',
    Analysing = 'Analysing',
    Training = 'Trainging',
    Preparing = 'Preparing',
    Uploading = 'Uploading'
}

export enum ImgRecImageQuality{
    Bad = 'Bad',
    Moderate = 'Moderate',
    Good = 'Good'
}

export enum ImgAnalysisStatus{
    NotSubmited = 0,
    Submitting = 1,
    Submitted = 2,
    Pending = 3,
    Finished = 4
}

export interface ImgRecCollection{
    cover_image: ZmlMediaFile | null
    created_at: string
    created_by: string
    id: string
    imageCount: number
    name: string
    queries: number
    status:string
    updated_at:string
    workspace:string
}

export interface ImgRecAnalysis{
    status:number
    statusUrl:string
    quality:string
    compositeURL:string

}
export interface ImgRecImage{
    id: string
    name:string
    collection: string,
    hits:number,
    mediafile:ZmlMediaFile
    analysis:ImgRecAnalysis
    userdata:string
}

export interface ImgRecCollectionList{
    count:number
    next:string
    previous:string
    results:ImgRecCollection[]
}

export interface ImgRecImageList{
    count:number
    next:string
    previous:string
    results:ImgRecImage[]
}

export interface ImgRecCollectionCell{
    id: string
    name: string
    status: string
    statusUrl: string
    queries:string
    url: string
    date: string
    count: string
}
export interface ImgRecImageCell{
    id:string
    collection:string
    name:string
    status: string 
    statusUrl:string
    quality: string 
    url:string
    date:string
    hits:string
    analysis:ImgRecAnalysis
}